import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import { cn } from "@/lib/utils";
import { SpineTemplate } from "../../../types/spine-template";
import { TemplateItem } from "./TemplateItem";

interface SortableRelatedTemplateItemProps {
  id: string;
  template: Partial<SpineTemplate>;
  onRemove: () => void;
}

export function SortableRelatedTemplateItem({
  id,
  template,
  onRemove,
}: SortableRelatedTemplateItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cn("flex gap-1 items-stretch", isDragging && "opacity-60")}
    >
      <button
        type="button"
        className="shrink-0 flex items-center justify-center w-8 rounded-md border border-border bg-muted/40 text-muted-foreground hover:bg-muted cursor-grab active:cursor-grabbing"
        title="拖拽排序（同类型内，越靠下层级越高）"
        {...attributes}
        {...listeners}
      >
        <GripVertical className="h-4 w-4" />
      </button>
      <div className="flex-1 min-w-0">
        <TemplateItem
          template={template}
          onRemove={onRemove}
          showAction
          isSelected
        />
      </div>
    </div>
  );
}
